import React from "react"
import Translate from "./Translate";


function Footer() {

    const now = new Date();

    return (
        <>
            <br />
            <footer className="p-3" style={{
                borderBottom: '1px double rgb(229, 232, 230)',
                borderTop: '1px double rgb(229, 232, 230)',
            }}>
                <small>
                    © {now.getFullYear()} Copyright. MATREC srl - CF/P.IVA 07775480960 - <Translate chiave="RIGHTS" pacchetto="Site" />.
                </small>
            </footer>
            <br />
        </>

    );
}

export default Footer;